export default class GetParameter {
  private param = new Map<string, string>()
  private url: URL

  constructor(url: string | URL) {
    if (typeof url === 'string') {
      // フルURL出ない場合は、変換する
      if (!url.startsWith('http')) {
        url = window.location.origin + url
      }

      this.url = new URL(url)
    } else {
      this.url = url
    }

    this.setGetParam(this.url)
  }

  /**
   * URLからGETパラメータを取得してクラス変数にセットする
   */
  private setGetParam(url: URL) {
    const urlSearch = url.search.substr(1).split('&')
    for (let i = 0; i < urlSearch.length; i++) {
      // "&"で分離したパラメータを"="で再分離
      const key = urlSearch[i].split('=')
      if (key[0] && key[1]) {
        this.set(key[0], decodeURIComponent(key[1]))
      }
    }
  }

  /**
   * 画面遷移する
   */
  public pageTransition(): void {
    window.location.href = this.getHref()
  }

  /**
   * リンク先を取得する
   */
  public getHref(): string {
    const paramString = this.createGetParamString()
    let url = this.url.origin + this.url.pathname
    if (paramString.length > 0) {
      url = url + '?' + paramString
    }
    return url + this.url.hash
  }

  /**
   * URLを取得する
   */
  public getUrl(): URL {
    return this.url
  }

  /**
   * パラメータを取得する
   *
   * 取得できなかった場合、空を返却する
   *
   * @param key パラメータ名
   * @return パラメータ値
   */
  public get(key: string): string {
    const value = this.param.get(key)
    if (value) {
      return value
    } else {
      return ''
    }
  }

  /**
   * パラメータをセットする
   * @param key パラメータ名
   * @param value パラメータ値
   */
  public set(key: string, value: string): void {
    if (value.length > 0) {
      value = escapeHTMLTag(value)
    }
    this.param.set(key, value)
  }

  /**
   * パラメータを削除する
   * @param key パラメータ名
   */
  public delete(key: string): void {
    this.param.delete(key)
  }

  /**
   * URLの#以降の文字列を取得
   * @returns
   */
  public getHash(): string {
    return this.url.hash
  }

  /**
   * パラメータが存在するかチェックする
   * @param key パラメータ名
   */
  public hasParamKey(key: string): boolean {
    return this.param.has(key)
  }

  /**
   * パラメータのリスト
   * @returns string[]
   */
  public getKeys(): string[] {
    return [...this.param.keys()]
  }

  /**
   * セットされているパラメータからGETパラメータ文字列を返却する
   * @param params パラメータ
   */
  public createGetParamString(): string {
    const result: string[] = []
    for (const [key, value] of this.param) {
      result.push(key + '=' + value)
    }
    return result.join('&')
  }

  /**
   * 現在のページからGETパラメータをセットする
   */
  public static currentGetParameter(): GetParameter {
    const obj = new GetParameter(window.location.href)
    return obj
  }
}

/**
 * サニタイジング
 * @param str 変換文字列
 */
export const escapeHTMLTag = (str: string) => {
  const escapeRules: { [s: string]: string } = {
    '&': '&amp;',
    '"': '&quot;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;'
  }
  return str.replace(/[&"<>]/g, function (c) {
    return escapeRules[c]
  })
}

/**
 * サニタイジングをデコード
 * @param str 変換文字列
 */
export const decodeHTMLTag = (str: string) => {
  return str.replace(/(&amp;|&lt;|&gt;|&quot;)/g, function (c) {
    const decodeRules: { [s: string]: string } = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'"
    }
    return decodeRules[c]
  })
}
